import md5 from 'md5';
/**
 *  ZbBuyCoupon 纯原生 JS 组件（买券 + 支付）
 *  用法：
 *    const popup = new ZbBuyCoupon({ env: 'test' });
 *    popup.init({
 *       appId, outMchNo, openId, plateNo, amount,
 *       onLoad(code){},            // 1=成功 0=失败
 *       onPay(){},                 // 普通支付
 *       onBuyCouponsPay(info){}    // 买券支付
 *    });
 *    // 支付完成或页面退出时
 *    popup.destroy();
 */

class ZbBuyCoupon {
	constructor(config = {}) {
		this.env = config.env || 'prod';
		this.baseUrlMap = {
			dev: 'https://dev.api.aipay.cloud',
			test: 'https://api.test.aipay.cloud',
			prod: 'https://api.aipay.cloud'
		};
		this.baseUrl = this.baseUrlMap[this.env] || this.baseUrlMap.prod;
		this.appSecret = 'a945abe1a510a204aec447d3a6155a3149a4b155';
		this.isSelected = config.defaultValue || false;
		this.themeColor = config.themeColor || 'rgba(0,122,255,1)'
		this.panelId =  config.panelId || '#zbPanelContainer';
		this.amount = '0.00'
		this.zb_current_info = {};
		this.couponInfo = {};
		this.couponName = '';

		this.callbacks = {
			onLoad: () => {},
			onPay: () => {},
			onBuyCouponsPay: () => {}
		};

		this.wrapperId = 'zb-buy-coupons-wrapper';
		this.styleId = 'zb-buy-coupons-style';
		
	}
	createPanelDOM() {
		try {
			if (document.getElementById(this.panelId.replace('#', ''))) {
				const warp = document.getElementById(this.panelId.replace('#', ''));
				console.log("page panel dom: ", warp)
				warp.innerHTML = `<div class="zb-coupon-slot"><div id="zb-coupon-panel"class="zb-coupon-panel"><div class="zb-coupon-panel-tag"></div><div class="zb-coupon-panel--title">超值券包，每日必省</div><input type="checkbox" id="zb-coupon-agree" /><label for="zb-coupon-agree"><div id="zb-click-checked" class="zb-coupon-panel--body"><div class="zb-coupon-panel--info"><div class="zb-coupon-panel--info-title"><div class="icon active-icon"></div><div>停车立减</div></div><div class="zb-coupon-panel--info-tip">${this.zb_current_info.panelContent.rule}</div></div><div class="zb-coupon-panel--price"><span>${this.zb_current_info.panelContent.amount}元</span><span class="zb-coupon-panel--unit">/多次</span></div><div id="zb-coupon-checkout" class="zb-coupon-checkout"><div class="icon"></div></div></div></label><div class="zb-coupon-panel--footer">权益类服务请仔细阅读内容，并知晓产品条款内容，如您同意请点击勾选。</div></div></div>`
				console.log("page panel inset success")
			} else {
				console.error("未获取到容器ID:", this.panelId)
			}
		} catch (error) {
			console.log(this.panelId +"|panel dom插入失败:", error)
		}
		
	}
	createDOM() {
		if (document.getElementById(this.wrapperId)) return;
		const opacity10 = this.setColorOpacity(this.themeColor, 10);
		const opacity80 = this.setColorOpacity(this.themeColor, 80);
		const opacity90 = this.setColorOpacity(this.themeColor, 90);
		const color1 = this.enhanceColor(this.themeColor)
		/* ① 样式 */
		const style = document.createElement('style');
		style.id = this.styleId;
		let styleInnerHtml = `:root{--zb-primary-color:${this.themeColor};}`;
		styleInnerHtml += `#zb-coupon-agree{position: absolute;opacity: 0;}#zb-coupon-agree:checked + label .zb-coupon-checkout .icon{background-color: var(--zb-primary-color);}`;
		styleInnerHtml += `.zb-coupon-panel{position:relative;border-radius:5.33vw;background-color:#fff;padding:3.2vw 3.2vw;box-sizing:border-box;box-shadow:0 1.067vw 3.2vw rgba(0,0,0,0.06);}.zb-coupon-panel-tag{position:absolute;left:1.33vw;top:1vw;width:8.5vw;height:8.5vw;background-image:url(https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/popup-tag.png);background-repeat:no-repeat;background-size:100% 100%;opacity:0.8;}`;
		styleInnerHtml += `.zb-coupon-panel--title{padding-left:6.5vw;padding-bottom:2vw;color:#fff;font-size:4.8vw;line-height:4.8vw;font-weight:bold;background:linear-gradient(90deg,${this.themeColor},${color1});-webkit-background-clip:text;-webkit-text-fill-color:transparent;}`;
		styleInnerHtml += `.zb-coupon-panel--body{position:relative;padding:3.2vw;background-color:#faf8fd;border-radius:6.4vw 6.4vw 0 0;display: flex;align-items: center;}.zb-coupon-panel--info {flex:1}.zb-coupon-panel--price {flex-shrink: 0;width: 30vw;font-size: 4.8vw;text-align: right;font-weight: bold;color: #ef5600;}.zb-coupon-panel--unit {font-size: 3.2vw;}.zb-coupon-panel--info-title .icon{flex-shrink:0;width:5.33vw;height:5.33vw;margin-right:1.2vw;-webkit-mask:url('https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/park-coupon.svg') no-repeat center / contain;mask:url('https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/park-coupon.svg') no-repeat center / contain;}.active-icon{background-color:var(--zb-primary-color);}.zb-coupon-panel--info-title{display:flex;align-items:center;font-size:4.26vw;line-height:1;padding-bottom:1vw;}.zb-coupon-panel--info-tip{font-size:3.24vw;color:#848288;}.zb-coupon-checkout{position:absolute;right:0;top:0;width:10vw;height:8.53vw;background:#eee;border-radius:0px 6.4vw 0px 6.4vw;display:flex;justify-content:center;align-items:center;}.zb-coupon-checkout .icon{width:6.4vw;height:6.4vw;background-color:#fff;-webkit-mask:url('https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/checkout.svg') no-repeat center / contain;mask:url('https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/checkout.svg') no-repeat center / contain;}`;
		styleInnerHtml += `.zb-coupon-panel--footer{font-size:3.2vw;padding-top:2.8vw;color:#d9d6da;}.zb-pay-footer{}.zb-is-fixed{position:fixed;left:0;right:0;bottom:0;padding-bottom:calc(constant(safe-area-inset-bottom) + 4vw);padding-bottom:calc(env(safe-area-inset-bottom) + 4vw);z-index:2}.zb-border-top{border-top:1px solid #eee;box-shadow:inset 0 1vw 1.4vw -1vw rgba(0,0,0,.07)}.zb-pay-footer{padding-left:2vw;padding-right:2vw;padding-top:2vw;display:flex;background:#fff;}.zb-pay-footer--amount{padding-bottom:1.5vw;flex:1;display:flex;align-items:flex-end;line-height:1;}.zb-pay-footer--label{font-size:4.26vw;color:#7e7c7f;margin-right:1vw;line-height:1;}.zb-pay-footer--unit{font-size:4.26vw;color:#ef5600;margin-right:0.4vw;line-height:1;}.zb-pay-footer--content{font-size:6vw;font-weight:bold;color:#ef5600;line-height:1;}.zb-pay-footer--btn{display:flex;align-items:center;justify-content:center;line-height:1;width:30vw;height:10vw;border-radius:6vw;background-color:var(--zb-primary-color);color:#fff;font-size:4.26vw;}.zb-pay-footer--btn:hover{opacity:.7;}`;
		styleInnerHtml += `.zb-popup--mask{display:none;position:fixed;left:0;right:0;bottom:0;top:0;background:rgba(0,0,0,0.7) no-repeat;background-size:100% 100%;}`;
		styleInnerHtml += `.zb-popup{display:none;position:fixed;left:0;right:0;bottom:0;z-index:2;background:#fff;border-radius:4.26vw 4.26vw 0 0;box-shadow:0 -1.07vw 5.33vw rgba(0,0,0,0.1);padding:5.33vw;max-height:90vh;overflow-x:hidden;overflow-y:auto;animation:slideUp 0.3s ease;background:linear-gradient(to bottom,${opacity90} 0%,rgba(0,122,255,.0) 20%,rgba(0,122,255,.0) 100%) #fff;}@keyframes slideUp{from{transform:translateY(100%);}to{transform:translateY(0);}}`;
		styleInnerHtml += `.zb-popup-tag{position:absolute;right:-4vw;top:-2.67vw;width:34.13vw;height:34.13vw;background-image:url(https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/popup-tag.png);background-repeat:no-repeat;background-size:100% 100%;opacity:0.2;transform:rotate(30deg);}.zb-popup-header{font-size:4.8vw;font-weight:bold;text-align:center;margin:0 0 1.067vw 0;color:#333;}.zb-popup-header--text{padding:0 0 3.2vw 0;}.zb-subtitle{padding:0 0 4.26vw 0;font-size:3.73vw;color:#666;}`;
		styleInnerHtml += `.zb-highlight-box{background:${opacity10};border:1px solid ${opacity80};color:var(--zb-primary-color);border-radius:3.2vw;padding:3.2vw;text-align:center;font-size:3.2vw;font-weight:bold;margin-bottom:5.33vw;display:flex;align-items:center;justify-content:center;gap:1.6vw;}.zb-highlight-box--price{font-size: 4.8vw;font-weight: bold;color: #ef5600;}`;
		styleInnerHtml += `.zb-feature{display:flex;align-items:flex-start;margin-bottom:16px;}.zb-feature-svg{flex-shrink:0;width:7.47vw;height:7.47vw;margin-right:3.2vw;}.zb-feature-content{}.zb-feature-content--title{padding-bottom:1vw;font-size:4vw;font-weight:600;color:#333;line-height:1;}.zb-feature-content--tip{font-size:3.47vw;margin:1.067vw 0 0;color:#666;line-height:1;}`;
		styleInnerHtml += `.zb-popup-footer{display:flex;gap:3.2vw;margin-top:5.33vw;}.zb-btn{flex:1;padding:3.2vw 0;border-radius:6.4vw;font-size:4.26vw;font-weight:600;text-align:center;cursor:pointer;border:none;}.zb-btn-cancel{background:#f1f1f1;color:#666;}.zb-btn-buy{background:var(--zb-primary-color);color:#fff;}`;
		style.innerHTML = styleInnerHtml;
		document.head.appendChild(style);
		/* ② 结构 */
		const wrap = document.createElement('div');
		wrap.id = this.wrapperId;
		wrap.style.display = 'none';
		let bodyInnerHTML = '';
		bodyInnerHTML = `<div class="zb-is-fixed zb-border-top zb-pay-footer"><div class="zb-pay-footer--amount"><div class="zb-pay-footer--label">需支付:</div><div class="zb-pay-footer--unit">¥</div><div id="zb-current-amount" class="zb-pay-footer--content">0.00</div></div><div id="zb-ask-buy" class="zb-pay-footer--btn">立即支付</div></div>`;
		bodyInnerHTML += `<div id="zb-custom-popup--mask" class="zb-popup--mask"></div><div id="zb-custom-popup--main" class="zb-popup zb-is-fixed"><div class="zb-popup-tag"></div><div class="zb-popup-header"><div class="zb-popup-header--text">${this.zb_current_info.dialogContent.title}</div><div class="zb-subtitle">${this.zb_current_info.dialogContent.subtitle}</div></div><div class="zb-highlight-box"><span class="zb-highlight-box--price">${this.zb_current_info.dialogContent.amount}元/多次</span> ${this.zb_current_info.dialogContent.alert}</div>`;
		for (let item of this.zb_current_info.dialogContent.list) {
			bodyInnerHTML += `<div class="zb-feature"><div class="zb-feature-svg active-icon"style="-webkit-mask: url(${item.icon}) no-repeat center / contain;mask: url(${item.icon}) no-repeat center / contain;"></div><div class="zb-feature-content"><div class="zb-feature-content--title">${item.label}</div><div class="zb-feature-content--tip">${item.value}</div></div></div>`;
		}
		bodyInnerHTML += `<div class="zb-popup-footer"><button id="zb-cancel-buy" class="zb-btn zb-btn-cancel">我不需要</button><button id="zb-confirm-buy" class="zb-btn zb-btn-buy">确认购买</button></div></div>`;
		wrap.innerHTML = bodyInnerHTML;
		document.body.appendChild(wrap);
		// 添加占位div
		const placeholder = document.createElement('div');
		placeholder.innerHTML = `<div style="height:25vw"></div>`
		document.body.appendChild(placeholder);
	}
	/* ---------- 事件 ---------- */
	bindEvents() {
		if (this._eventBound) return;
		this._eventBound = true;

		/* 协议弹窗开关 */
		const showMask = () => {
			document.getElementById('zb-custom-popup--mask').style.display = 'block';
			document.getElementById('zb-custom-popup--main').style.display = 'block';
		};
		const hideMask = () => {
			document.getElementById('zb-custom-popup--mask').style.display = 'none';
			document.getElementById('zb-custom-popup--main').style.display = 'none';
		};
		
		document.getElementById("zb-ask-buy").onclick = e => {
			e.stopPropagation();
			if (document.getElementById('zb-coupon-agree').checked) {
				this.callbacks.onBuyCouponsPay(this.couponInfo);
			} else {
				showMask();
			}
		};

		if (document.getElementById("zb-click-checked")) {
			document.getElementById("zb-click-checked").onclick = () => {
				setTimeout(() => {
					this.toggleAmount()
				}, 60)
			}
		}
		
		document.getElementById('zb-confirm-buy').onclick = () => {
			document.getElementById('zb-coupon-agree').checked = true;
			hideMask();
			this.callbacks.onBuyCouponsPay(this.couponInfo);
		};
		document.getElementById('zb-cancel-buy').onclick = () => {
			hideMask();
			this.callbacks.onPay();
		};
	}
	toggleAmount() {
		if (document.getElementById('zb-coupon-agree') && document.getElementById("zb-current-amount")) {
			if (document.getElementById('zb-coupon-agree').checked) {
				const couponAmount = this.couponInfo.amount || 0;
				const total = ((couponAmount + this.amount) / 100).toFixed(2)
				document.getElementById("zb-current-amount").innerText = total
			} else {
				document.getElementById("zb-current-amount").innerText = (this.amount / 100).toFixed(2)
			}
		}
		
	}
	/* ---------- 签名 ---------- */
	generateSign(params) {
		const filtered = {};
		Object.keys(params).forEach(k => {
			if (k !== 'sign' && params[k] != null) filtered[k] = params[k];
		});
		const sortedKeys = Object.keys(filtered).sort();
		const paramStr = sortedKeys.map(k =>
			`${k}=${typeof filtered[k]==='object' ? JSON.stringify(filtered[k]) : filtered[k]}`).join('&');
		return md5(`${paramStr}&key=${this.appSecret}`).toLowerCase();
	}
	/* ---------- 入口 ---------- */
	init(params) {
		this.callbacks.onLoad = params.onLoad || (() => {});
		this.callbacks.onPay = params.onPay || (() => {});
		this.callbacks.onBuyCouponsPay = params.onBuyCouponsPay || (() => {});
		this.amount = params.amount;
		const reqTime = ~~(Date.now() / 1000);
		const body = {
			appId: params.appId,
			reqTime,
			outMchNo: params.outMchNo,
			openId: params.openId,
			plateNo: params.plateNo,
			amount: params.amount,
			version: 100
		};
		body.sign = this.generateSign(body);

		fetch(`${this.baseUrl}/pay/market/init`, {
				method: 'POST',
				body: JSON.stringify(body),
				headers: {
					'Content-Type': 'application/json'
				}
			})
			.then(r => r.json())
			.then(res => {
				if (res.code === 200) {
					const data = res.data || {}
					this.couponInfo = data || {}
					this.zb_current_info = {
						panelContent: {
							title: '超值券包，每日必省',
							subtitle: '停车立减',
							rule: `${data.couponInfo.label}｜全场通用｜${data.date}内均可使用｜自动抵扣，无需操作｜未用随时退`,
							tips: '权益类服务请仔细阅读内容，并知晓产品条款内容，如您同意请点击勾选。',
							amount: (data.amount / 100).toFixed(2)
						},
						dialogContent: {
							title: '停车省钱，每日必省',
							subtitle: '每日停车自动减，省下的都是赚到的',
							alert: `本次停车已立减 ¥${(data.reduction / 100).toFixed(2)}`,
							amount: (data.amount / 100).toFixed(2),
							list: [{
									icon: 'https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/park-coupon-text.svg',
									label: `${data.couponInfo.label}`,
									value: `${data.couponInfo.value}`
								},
								{
									icon: 'https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/scope.svg',
									label: '全场通用',
									value: '覆盖平台所有合作停车场，无忧使用'
								},
								{
									icon: 'https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/date.svg',
									label: `有效期 ${data.date}`,
									value: `自购买后${data.date}内均可使用，灵活方便`
								},
								{
									icon: 'https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/rule.svg',
									label: '自动抵扣，无需操作',
									value: '停车费超出券额时，支付时自动减免，零门槛'
								},
								{
									icon: 'https://aipay-image.oss-cn-beijing.aliyuncs.com/report/js/svg/safety.svg',
									label: '未用随时退',
									value: '有效期内未使用的券，支持随时全额退款'
								}
							]
						}

					}
					this.onSdkReady(this.panelId, (err, rootEl) => {
						if (err) {
							console.error('优惠券初始化失败', err.message);
							this.callbacks.onLoad(0);
							return;
						}
						console.log("===页面加载完成，开始初始化券包===")
						this.createDOM();
						this.createPanelDOM();
						this.bindEvents();
						document.getElementById(this.wrapperId).style.display = 'block';
						
						this.callbacks.onLoad(1);
						if (this.isSelected) {
							document.getElementById('zb-coupon-agree').checked = true;
						}
						this.toggleAmount()
						
					})
					
				} else this.callbacks.onLoad(0);
			})
			.catch(e => {
				console.error('优惠券初始化失败', e);
				this.callbacks.onLoad(0);
			});
	}

	/* ---------- 销毁 ---------- */
	destroy() {
		document.getElementById(this.wrapperId)?.remove();
		document.getElementById(this.styleId)?.remove();
		this.zb_current_info = {};
		this.couponInfo = {};
		this.callbacks = {};
		this._eventBound = false;
	}
	onPageLoad(callback) {
	    if (typeof callback !== 'function') return;
	    
	    if (document.readyState !== 'loading') {
	        // 文档已经加载完成，直接执行
	        setTimeout(callback, 0);
	    } else {
	        // 文档还在加载中，添加事件监听
	        document.addEventListener('DOMContentLoaded', callback);
	    }
	}
	
	onSdkReady(selector, callback, timeout = 3000) {
	  if (typeof callback !== 'function') return;
		console.log(document.querySelector(selector))
	  if (document.readyState !== 'loading') {
	    this.waitForContent(selector, callback, timeout);
	  } else {
	    document.addEventListener('DOMContentLoaded', () => {
	      this.waitForContent(selector, callback, timeout);
	    });
	  }
	}
	
	waitForContent(selector, callback, timeout) {
	  const startTime = Date.now();
	
	  function check() {
	    const el = document.querySelector(selector);
	    if (el) {
	      observer && observer.disconnect();
	      clearTimeout(timer);
	      callback(null, el); // ✅ 成功时返回 (err=null, el)
	      return true;
	    }
	    return false;
	  }
	
	  // 立即检查一次
	  if (check()) return;
	
	  // 监听 DOM 变化
	  const observer = new MutationObserver(() => check());
	  observer.observe(document.body, { childList: true, subtree: true });
	
	  // 超时处理
	  const timer = setTimeout(() => {
	    observer.disconnect();
	    callback(new Error(`容器 ${selector} 在 ${timeout}ms 内未加载完成`), null);
	  }, timeout);
	}


	
	/*
	* 修改RGBA颜色的透明度
	* @param {string} rgbaStr - 输入的RGBA字符串，格式如 "rgba(0, 122, 255, 1)"
	* @param {number} opacity - 透明度值 (0-100)
	* @returns {string} - 转换后的RGBA字符串
	*/
	setColorOpacity(rgbaStr, opacity) {
	    // 从RGBA字符串中提取数值
	    const rgbaMatch = rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i);
	    
	    if (!rgbaMatch) {
	        throw new Error('Invalid RGBA format');
	    }
	    
	    // 解析RGBA值
	    const r = parseInt(rgbaMatch[1]);
	    const g = parseInt(rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i)[2]);
	    const b = parseInt(rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i)[3]);
	    
	    // 将透明度百分比转换为0-1范围
	    const alpha = Math.min(100, Math.max(0, opacity)) / 100;
	    
	    // 返回新的RGBA字符串
	    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`;
	}
	
	rgbaToHsl(r, g, b) {
	  r /= 255;
	  g /= 255;
	  b /= 255;
	  const max = Math.max(r, g, b);
	  const min = Math.min(r, g, b);
	  let h, s, l = (max + min) / 2;
	
	  if (max === min) {
	    h = s = 0; // 灰色
	  } else {
	    const d = max - min;
	    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	    switch (max) {
	      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	      case g: h = (b - r) / d + 2; break;
	      case b: h = (r - g) / d + 4; break;
	    }
	    h /= 6;
	  }
	  return [h, s, l];
	}
	
	hslToRgba(h, s, l, a = 1) {
	  let r, g, b;
	
	  if (s === 0) {
	    r = g = b = l; // 灰色
	  } else {
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	    const p = 2 * l - q;
	    r = hue2rgb(p, q, h + 1 / 3);
	    g = hue2rgb(p, q, h);
	    b = hue2rgb(p, q, h - 1 / 3);
	  }
	
	  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, ${a})`;
	}
	
	enhanceColor(rgbaStr, sFactor = 1.1, lFactor = 1.2) {
	  const match = rgbaStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]*)\)/);
	  if (!match) throw new Error("Invalid rgba format");
	
	  const r = parseInt(match[1], 10);
	  const g = parseInt(match[2], 10);
	  const b = parseInt(match[3], 10);
	  const a = match[4] === "" ? 1 : parseFloat(match[4]);
	
	  let [h, s, l] = this.rgbaToHsl(r, g, b);
	
	  // 调整
	  s = Math.min(1, s * sFactor);
	  l = Math.min(1, l * lFactor);
	
	  return this.hslToRgba(h, s, l, a);
	}
}

window.ZbBuyCoupon = ZbBuyCoupon;
export default ZbBuyCoupon;